<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>panorama</md-icon>
          </div>
          <h4 class="title">Create New Category</h4>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Title</label>
            <md-input v-model="title" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Slug</label>
            <md-input v-model="slug" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Description</label>
            <md-input v-model="description" type="text"></md-input>
          </md-field>
          <md-field>
            <input type="file" @change="fileUpload( $event )"  /> 
          </md-field>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button class="md-success" :disabled="isDisabled" @click="createCategory()">
            Create <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import CategoryService from "../../../services/CategoryService";
export default {
  components: {},
  data() {
    return {
      clientId: this.$route.query.id,
      isDisabled: false,
      title: "",
      slug: "",
      description:"",
      categoryImage:"",
    };
  },
  methods: {
    fileUpload(event){
      this.categoryImage = event.target.files[0];
    },
    async createCategory() {
      this.isDisabled = true;
      let formData = new FormData();
      formData.append("categoryImage", this.categoryImage);
      formData.append("title", this.title);
      formData.append("slug", this.slug);
      formData.append("description", this.description);
      await CategoryService.createCategory(formData)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.$router.push('categories');
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  watch: {
    title(newTitle) {
      // Generate slug from title
      this.slug = newTitle
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '') // remove invalid chars
        .replace(/\s+/g, '-')         // replace spaces with -
        .replace(/-+/g, '-');         // collapse multiple -
    }
  },
  beforeMount() {
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}
</style>
